import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const multiIndicatorRingGaugeValidationConfig: ValidationConfig = {
  fields: [
    // 多指标环状仪表盘的x字段是数组，使用特殊验证
  ],
  businessRules: [
    {
      name: 'multi-indicator-x-array-validation',
      validator: (data, layer) => {
        const { encoding } = layer;
        // 检查x字段是否为数组
        if (!Array.isArray(encoding?.x)) {
          return false;
        }
        if (!Array.isArray(data) || data.length === 0) {
          return true; // No data to validate against, so pass.
        }
        const firstRow = data[0] as Record<string, unknown>;
        // 检查每个x字段是否为数值类型
        return encoding.x.every(xField => typeof firstRow[xField] === 'number');
      },
      message: 'Multi-indicator ring gauge requires x field to be an array of numeric fields',
      suggestion: 'Provide an array of numeric field names for the x encoding',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    },
    {
      name: 'multi-indicator-exact-data-count',
      validator: data => Array.isArray(data) && data.length === 1,
      message: 'Multi-indicator ring gauge requires exactly 1 data point',
      suggestion: 'Provide exactly one data row with multiple indicator values',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
